<template>
    <div class="p-8 bg-gray-200 min-h-screen">

        <div class="text-center mb-4"><div class="bg-red-500 text-white rounded-full inline-flex w-10 h-10 items-center text-center"><IconHandSolid  size="8" class="mx-auto"></IconHandSolid></div></div>
        
        
        <div class="pb-5">
            <h3 class="text-lg leading-6 font-medium text-red-600">
                {{ _("%s has paused their menu; this order cannot be completed. Please try at a later time.").split("%s").join(restaurant.name)  }}
            </h3>
        </div>
        
        
    </div>
</template>

<script>

import {lang} from "../../lang";
import IconLocationMarkerSolid from "../../../icons/solid/IconLocationMarkerSolid";
import IconCheckSolid from "../../../icons/solid/IconCheckSolid";
import IconStopSolid from "../../../icons/solid/IconStopSolid";
import IconHandSolid from "../../../icons/solid/IconHandSolid";

export default {
  name: "Index",
    props: ['restaurant', 'app_locale'],
    components: {
        IconHandSolid,
        IconStopSolid,
        IconCheckSolid,
        IconLocationMarkerSolid
      
    },
    
    
    data() {
        return {
            
        }
    },
    methods: {

        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
    
}
</script>

<style scoped>

</style>
